<template>
  <md-table-row
    class="home-table-row"
    :class="{
      'animate-row-fade': item.rowShouldAnimateUpdate,
      'row-for-review': item.needsReview
    }"
    @click="openUserStudy(item.id)"
    v-if="item.params"
  >
    <md-table-cell class="row-dense" md-sort-by="needsReview">
      <md-icon v-if="item.needsReview" class="md-accent">flag</md-icon>
      <md-icon v-else-if="item.params.updatedBy == 'user'">edit</md-icon>
      <md-icon v-else-if="item.params.acknowledged">check</md-icon>
      <md-icon v-else>hourglass_empty</md-icon>
    </md-table-cell>
    <md-table-cell md-label="ID" md-sort-by="pID">
      {{ item.pID }}
    </md-table-cell>
    <md-table-cell md-label="Week" md-sort-by="studyWeek">
      <v-chip v-if="item.studyWeek">{{ item.studyWeek }}</v-chip>
    </md-table-cell>
    <md-table-cell md-label="Group">
      {{ item.group && dbGroups[item.group] ? dbGroups[item.group].name : "N/A" }}
    </md-table-cell>
    <md-table-cell md-label="TIR (%)" md-sort-by="timeInRange" md-numeric>
      <transition name="slide-fade" mode="out-in">
        <v-progress-circular
          :size="20"
          :width="2"
          color="primary"
          indeterminate
          v-if="!timeInRangeLoaded"
        ></v-progress-circular>
        <div v-else>{{ formatOutcome(timeInRange) }}</div>
      </transition>
    </md-table-cell>
    <md-table-cell md-label="< 3.9 (%)" md-sort-by="timeInHypo" md-numeric>
      <transition name="slide-fade" mode="out-in">
        <v-progress-circular
          :size="20"
          :width="2"
          color="primary"
          indeterminate
          v-if="!timeInHypoLoaded"
        ></v-progress-circular>
        <div v-else>{{ formatOutcome(timeInHypo) }}</div>
      </transition>
    </md-table-cell>
    <md-table-cell md-label="> 10 (%)" md-sort-by="timeInHyper" md-numeric>
      <transition name="slide-fade" mode="out-in">
        <v-progress-circular
          :size="20"
          :width="2"
          color="primary"
          indeterminate
          v-if="!timeInHyperLoaded"
        ></v-progress-circular>
        <div v-else>{{ formatOutcome(timeInHyper) }}</div>
      </transition>
    </md-table-cell>
    <md-table-cell md-label="HbA1c (%)" md-sort-by="hba1c" md-numeric>
      <transition name="slide-fade" mode="out-in">
        <v-progress-circular
          :size="20"
          :width="2"
          color="primary"
          indeterminate
          v-if="!hba1cLoaded"
        ></v-progress-circular>
        <div v-else>{{ formatOutcome(hba1c) }}</div>
      </transition>
    </md-table-cell>
    <md-table-cell
      md-label="Sensor use (%)"
      md-sort-by="timeInSensor"
      md-numeric
    >
      <transition name="slide-fade" mode="out-in">
        <v-progress-circular
          :size="20"
          :width="3"
          color="primary"
          indeterminate
          v-if="!timeInSensorLoaded"
        ></v-progress-circular>
        <div v-else>{{ formatOutcome(timeInSensor) }}</div>
      </transition>
    </md-table-cell>
    <md-table-cell md-label="Logs/day (avg)" md-sort-by="logsPerDay" md-numeric>
      {{ formatOutcome(logsPerDay) }}
      <template v-if="item['f-notifyUserInactivity']">
        <v-icon dense color="error" v-if="item['f-notifyUserInactivity'].error"
          >warning</v-icon
        >
        <v-icon dense color="warning" v-else>warning</v-icon>
        <md-tooltip md-direction="bottom">
          {{
            item["f-notifyUserInactivity"].error
              ? "Error sending notification"
              : "Sent notification"
          }}
          {{ item["f-notifyUserInactivity"].t | moment("from") }}
        </md-tooltip>
      </template>
    </md-table-cell>

    <!-- <md-table-cell
      md-label="Last parameters update"
      >{{ item.params.timestamp | moment("from") }} (<i>{{
        item.params.updatedBy
      }}</i
      >)</md-table-cell
    > -->
    <!-- <md-table-cell md-label="Latest log entry" md-sort-by="latestLog">
      <span v-if="item.latestLog">{{ item.latestLog | moment("from") }}</span>
      <span v-else>N/A</span>
    </md-table-cell> -->
    <!-- <md-table-cell md-label="Latest login" md-sort-by="latestLogin">
      <span v-if="item.latestLogin">{{
        item.latestLogin | moment("from")
      }}</span>
      <span v-else>N/A</span>
    </md-table-cell> -->
    <md-table-cell class="row-dense">
      <md-icon v-if="item.requiredToOpenSurvey" class="md-accent">mail</md-icon>
      <md-icon v-else-if="surveyClick" class="md-primary"
        >drafts
        <md-tooltip md-direction="left">{{
          surveyClick | moment("from")
        }}</md-tooltip>
      </md-icon>
    </md-table-cell>
  </md-table-row>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");

export default {
  props: ["item", "pastWeekStart"],
  data: () => ({
    timeInRangeLoaded: false,
    timeInHypoLoaded: false,
    timeInHyperLoaded: false,
    timeInSensorLoaded: false,
    logsPerDayLoaded: false,
    hba1cLoaded: false,
    timeInRange: null,
    timeInHypo: null,
    timeInHyper: null,
    timeInSensor: null,
    logsPerDay: null,
    hba1c: null,
    surveyClick: null
  }),
  computed: {
    ...mapState([
      "adminUser",
      "dbAdminParamsToReview",
      "dbGroups",
      "dbAdminParticipantDetails",
      "weekStartDay"
    ])
  },
  created() {
    this.loadParticipantDetail("timeInRange");
    this.loadParticipantDetail("timeInHypo");
    this.loadParticipantDetail("timeInHyper");
    this.loadParticipantDetail("timeInSensor");
    this.loadParticipantDetail("logsPerDay");
    this.loadParticipantHba1c();
    this.loadLatestSurveyClick();
  },
  methods: {
    openUserStudy(uid) {
      this.$router.push({ path: `/user/${uid}` });
    },
    formatOutcome(outcome) {
      return outcome !== null && outcome !== undefined && outcome !== ""
        ? Number(outcome).toFixed(1)
        : "N/A";
    },
    loadParticipantDetail(property) {
      fb.GraphDataWeeklyRef.child(this.item.id)
        .child(this.pastWeekStart)
        .child(property)
        .once("value", snap => {
          this[`${property}Loaded`] = true;
          let data = snap.val();
          this[property] = data;
          this.item[property] = data;
        });
    },
    loadParticipantHba1c() {
      fb.AdminParticipantDetailsRef.child(this.item.id)
        .child("hba1c")
        .once("value", snap => {
          this.hba1cLoaded = true;
          const data = snap.val();
          if (data && data.length > 0) {
            let value = Number(data[data.length - 1].value).toFixed(1);
            this.hba1c = value;
            this.item.hba1c = Number(value);
          } else {
            this.item.hba1c = null;
          }
        });
    },
    loadLatestSurveyClick() {
      fb.SurveyClicksRef.orderByChild("study")
        .equalTo(this.item.id)
        .limitToLast(1)
        .once("value", snap => {
          const data = snap.val();
          if (data) {
            const value = Object.values(data)[0];
            this.surveyClick = value.timestamp;
          }
        });
    }
  }
};
</script>
